import React from 'react';
import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// Styled Tabs with brand color background and white text
export const StyledTabs = styled(Tabs)({
    backgroundColor: '#1f2641', // Brand color for background
    '& .MuiTabs-indicator': {
        backgroundColor: 'white', // White color for the indicator (underline)
    },
});

// Styled Tab with white text
export const StyledTab = styled((props) => <Tab disableRipple {...props} />)({
    textTransform: 'none',
    color: 'white', // White text color
    '&.Mui-selected': {
        color: 'white', // White text color for selected tab
        fontWeight: 'bold', // Optional: Makes the selected tab's text bold
    },
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)', // Light white overlay on hover
    },
});
